{
  "experiments": {
    "adblock_allowlisting": {
      "id": "100148588",
      "ticket": "SF-3256",
      "variants": { "a": "1001236384", "b": "1001236385" },
      "original": "a"
    },
    "studybuddy": {
      "id": "100146352",
      "ticket": "SF-3009",
      "variants": { "a": "1001231371", "b": "1001231372" },
      "original": "a"
    },
    "homepage_ad_slider": {
      "id": "100146704",
      "ticket": "SF-3146",
      "variants": { "a": "1001232206", "b": "1001232207" },
      "original": "a"
    },
    "video_company_ad_slider": {
      "id": "100146860",
      "ticket": "SF-3080",
      "variants": { "a": "1001232541", "b": "1001232542" },
      "original": "a"
    },
    "video_pre_ad_role_selection": {
      "id": "100147841",
      "ticket": "SF-3213",
      "variants": { "a": "1001234716", "b": "1001234717" },
      "original": "a"
    },
    "subject_area_header_ad": {
      "id": "100146706",
      "ticket": "SF-3147",
      "variants": { "a": "1001232210", "b": "1001232211" },
      "original": "a"
    },
    "video_continue_after_ad_click": {
      "id": "100146707",
      "ticket": "SF-3149",
      "variants": { "a": "1001232212", "b": "1001232213" },
      "original": "a"
    },
    "survey_learning_intent": {
      "id": "100147939",
      "ticket": "SF-3193",
      "variants": { "a": "1001234936", "b": "1001234937" },
      "original": "a"
    },
    "user_home_hub": {
      "id": "100148217",
      "ticket": "SF-3215",
      "variants": { "a": "1001235545", "b": "1001235546" },
      "original": "a"
    },
    "onboarding": {
      "id": "100147858",
      "ticket": "SF-3211",
      "variants": { "a": "1001234750", "b": "1001234751" },
      "original": "a"
    },
    "burger_menu": {
      "id": "100147845",
      "ticket": "SF-3212",
      "variants": { "a": "1001234724", "b": "1001234725" },
      "original": "a"
    },
    "video_career_opportunity_button": {
      "id": "100149032",
      "ticket": "SF-3292",
      "variants": { "a": "1001237438", "b": "1001237439" },
      "original": "a"
    },
    "video_ad_timer_progress_bar": {
      "id": "100149034",
      "ticket": "SF-3293",
      "variants": { "a": "1001237442", "b_5s": "1001237443", "b_3s": "1001237444" },
      "original": "a"
    }
  },
  "goals": {
    "video_percentage": "100150969",
    "session_start": "100154631",
    "video_ad_click": "100149176",
    "adblock_detected": "100155209",
    "adblock_not_detected": "100155208"
  },
  "locations": {
    "adblock_detected": "100112345"
  }
}
